import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { MyTextInput } from "../services/authentication/inputServices";
import { Store } from "react-notifications-component";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { Switch } from "@mui/material";
import {
  getAlltag,
  AddTag,
  delete_tag,
  update_tag,
  updateTagStatus,
} from "../services/web/webServices";
import Loader from "../components/Helpper/Loader";

function TagManagement() {
  const theme = useTheme();
  const navigate = useNavigate();

  const [getButton, setButton] = useState(true);
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const [show, setShow] = useState(false);
  const [rowData, setRowData] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = (params) => {
    setRowData(params);
    setSelectedId(params.row.id);
    setShow(true);
  };

  const [showEye, setShowEye] = useState(false);

  const handleClose1 = () => setShowEye(false);
  const handleShow1 = () => setShowEye(true);
  const pageName = "Tags Management";
  const onDelete = (params) => () => {
    if (window.confirm("Are you sure you want to delete this tag?")) {
      delete_tag(params.row.id)
        .then((res) => {
          Store.addNotification({
            title: "Success",
            message: res?.data?.message,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });

          setLoader(true);
          getAlltag()
            .then((res) => {
              // setUserDetail(res.data.user);
              const tags = Array.isArray(res?.data?.data) ? res.data.data : [];
              settagData(
                tags.map((el, index) => ({
                  ...el,
                  id: el.id,
                  i: index,
                }))
              );
              setLoader(false);
            })

            .catch((err) => {
              setLoader(false);
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const columns = [
    {
      field: "sno",
      headerName: "S.NO.",
      filterable: false,
      renderCell: (index) => `${index.row.i + 1}`,
      width: 100,
    },

    {
      field: "title",
      headerName: "Tags",
      width: 160,
    },

    {
      field: "title_sp",
      headerName: "Tags in Spanish",
      width: 160,
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      renderCell: (params) => {
        const isActive = params.row.status === "active";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Switch
              checked={isActive}
              onChange={handleStatusToggle(params)}
              color="success"
            />
            <span style={{ textTransform: "capitalize" }}>
              {isActive ? "Active" : "InActive"}
            </span>
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 310,

      renderCell: (params) => {
        return (
          <>
            <Button
              style={{
                backgroundColor: "#64A433",
                border: "none",
                marginRight: "5px",
              }}
              onClick={() => handleShow(params)}
            >
              <i className="fas fa-edit"></i>
            </Button>

            <Button
              color="error"
              onClick={onDelete(params)}
              style={{ backgroundColor: "#64A433", border: "none" }}
            >
              <i className="fa fa-trash" aria-hidden="true"></i>
            </Button>
          </>
        );
      },
    },
  ];

  const css = `


.modal-dialog {
  position: relative;
  margin: auto;
  margin-top: 10%;
  width: 80%;
  max-width: 600px;
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
}

.modal-title {
  margin-bottom: 0;
}

.modal-body {
  padding: 20px 0;
}

.modal-footer {
  border-top: 1px solid #ccc;
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.form-group {
  margin-bottom: 20px;
}
.form-label {
  margin-bottom: 5px;
  display: block;
  font-weight: bold;
  color: #555659; 
}

.form-control {
  width: 100%;
  padding: 8px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}


  .form-submit{
    padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;  
  border-radius: 5px;
  }
.form-submit:hover {
  background-color: #4CAF50; /* Darker green on hover */
  transform: scale(1.05); /* Slightly enlarge the button */
}

.form-submit:disabled {
  background-color: #9e9e9e; /* Grey color when disabled */
  cursor: not-allowed; /* Change cursor to not-allowed when disabled */
}
   label {
  color: #555659; 
}
  `;

  const [tagData, settagData] = useState([]);
  const [select, setSelection] = useState([]);
  const [getLoader, setLoader] = useState(true);

  console.log("5555555555555555555", tagData);
  useEffect(() => {
    setLoader(true);
    getAlltag()
      .then((res) => {
        const tags = Array.isArray(res?.data?.data) ? res.data.data : [];
        settagData(
          tags.map((el, index) => ({
            ...el,
            id: el.id,
            i: index,
          }))
        );
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }, []);

  const handleStatusToggle = (params) => async () => {
    const currentStatus = params.row.status;
    const newStatus = currentStatus === "active" ? "inActive" : "active";

    if (
      window.confirm(`Are you sure you want to mark this tag as ${newStatus}?`)
    ) {
      try {
        await updateTagStatus(params.row.id, { status: newStatus });

        Store.addNotification({
          title: "Success",
          message: `Tag status updated to ${newStatus}`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });

        setLoader(true);
        getAlltag()
          .then((res) => {
            const tags = Array.isArray(res?.data?.data) ? res.data.data : [];
            settagData(
              tags.map((el, index) => ({
                ...el,
                id: el.id,
                i: index,
              }))
            );
            setLoader(false);
          })
          .catch((err) => {
            setLoader(false);
            console.log("Error while refreshing tags:", err);
          });
      } catch (error) {
        console.error("Failed to update tag status", error);
      }
    }
  };

  return (
    <>
      <style>{css}</style>
      <div className="grid-container">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
        <Header OpenSidebar={OpenSidebar} pageName={pageName} />
        <div
          style={{
            gridArea: "main",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            // margin: "0 150px 150px",
            margin: "0 90px 150px",
          }}
        >
          <div
            style={{
              margin: "30px",
              display: "flex",
              alignItems: "center", // Center items vertically
              justifyContent: "flex-end", // Align items to the end of the container
              marginRight: "50px", // Adjust margin to your preference
            }}
          >
            <Button
              onClick={handleShow1}
              style={{
                marginLeft: "750px",
                backgroundColor: "#64A433",
                border: "none",
              }}
            >
              Add Tag +
            </Button>
          </div>

          <Box sx={{ height: 400, width: "100%", boxShadow: 7 }}>
            {getLoader ? (
              <Loader />
            ) : tagData.length > 0 ? (
              <>
                <h2>{select.map((val) => val._id)}</h2>
                <DataGrid
                  rows={tagData}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  pageSizeOptions={[5, 10, 20]}
                  // checkboxSelection
                  disableRowSelectionOnClick
                  onSelectionChange={(newSelection) => {
                    setSelection(newSelection.rows);
                  }}
                  sx={{
                    "& .MuiDataGrid-row:nth-of-type(odd)": {
                      backgroundColor: theme.palette.action.hover, // Light grey background
                    },
                    "& .MuiDataGrid-cell:last-child": {
                      border: 0, // Hide the last cell border
                    },
                  }}
                />
              </>
            ) : (
              <p style={{ fontSize: "30px", padding: "30px" }}>
                No data found.
              </p>
            )}
          </Box>
          {/* modal of edit tag-------------------------- */}

          <Modal
            show={show}
            onHide={handleClose}
            className="tag-management-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit Tag Title</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={{
                  title: rowData?.row?.title ? rowData?.row?.title : "",
                  title_sp: rowData?.row?.title_sp
                    ? rowData?.row?.title_sp
                    : "",
                }}
                validationSchema={Yup.object({
                  title: Yup.string()
                    .required("Please Enter title")
                    .min(3, "Title must be at least 3 characters")
                    .max(25, "Title must be 25 characters or less"),

                  title_sp: Yup.string()
                    .required("Please Enter title in spanish")
                    .min(3, "Title must be at least 3 characters")
                    .max(25, "Title must be 25 characters or less"),
                })}
                onSubmit={(values, { resetForm }) => {
                  setButton(false);

                  update_tag(selectedId, values)
                    .then((res) => {
                      setButton(true);

                      Store.addNotification({
                        title: "Success",
                        message: res.data?.message,
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                          duration: 5000,
                          onScreen: true,
                        },
                      });
                      setLoader(true);
                      getAlltag()
                        .then((res) => {
                          const tags = Array.isArray(res?.data?.data) ? res.data.data : [];
                          settagData(
                            tags.map((el, index) => ({
                              ...el,
                              id: el.id,
                              i: index,
                            }))
                          );
                          setLoader(false);
                        })

                        .catch((err) => {
                          setLoader(false);
                          console.log(err);
                        });
                      handleClose();
                    })
                    .catch((error) => {
                      setButton(true);
                      if (error) {
                        Store.addNotification({
                          title: "Error!",
                          message: error?.response?.data?.message,
                          type: "danger",
                          insert: "top",
                          container: "top-right",
                          animationIn: ["animate__animated", "animate__fadeIn"],
                          animationOut: [
                            "animate__animated",
                            "animate__fadeOut",
                          ],
                          dismiss: {
                            duration: 5000,
                            onScreen: true,
                          },
                        });
                      }
                    });
                }}
              >
                {(props) => (
                  <Form>
                    <div className="form-group">
                      <label className="form-label">Title:</label>
                      <MyTextInput
                        type="text"
                        id="title"
                        name="title"
                        className="form-control"
                        placeholder="Enter title"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Title in Spanish:</label>
                      <MyTextInput
                        type="text"
                        id="title_sp"
                        name="title_sp"
                        className="form-control"
                        placeholder="Enter title in Spanish"
                      />
                    </div>
                    {getButton === true ? (
                      <Button type="submit" className="form-submit">
                        Update
                      </Button>
                    ) : (
                      <Button type="submit" className="form-submit" disabled>
                        Please Wait!!
                      </Button>
                    )}
                  </Form>
                )}
              </Formik>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          {/* modal of add tag+------------------------------------------ */}
          <Modal
            show={showEye}
            onHide={handleClose1}
            className="tag-management-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>Add Tag</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={{
                  title: "",
                  title_sp: "",
                }}
                validationSchema={Yup.object({
                  title: Yup.string().required("Please Enter title")
                    .min(3, "Title must be at least 3 characters")
                    .max(50, "Title must be 50 characters or less"),
                  title_sp: Yup.string().required("Please Enter Spanish title")
                    .min(3, "Spanish title must be at least 3 characters")
                    .max(50, "Spanish title must be 50 characters or less"),
                })}
                onSubmit={(values, { resetForm }) => {
                  setButton(false);

                  AddTag(values)
                    .then((res) => {
                      console.log("Login success:", res);
                      setButton(true);

                      Store.addNotification({
                        title: "Success",
                        message: res.data?.message,
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                          duration: 5000,
                          onScreen: true,
                        },
                      });
                      resetForm({ values: "" });
                      setLoader(true);
                      getAlltag()
                        .then((res) => {
                          const tags = Array.isArray(res?.data?.data) ? res.data.data : [];
                          settagData(
                            tags.map((el, index) => ({
                              ...el,
                              id: el.id,
                              i: index,
                            }))
                          );
                          setLoader(false);
                        })
                        .catch((err) => {
                          setLoader(false);
                          console.log(err);
                        });
                      handleClose1();
                    })
                    .catch((error) => {
                      setButton(true);
                      if (error) {
                        Store.addNotification({
                          title: "Error!",
                          message: error?.response?.data?.message,
                          type: "danger",
                          insert: "top",
                          container: "top-right",
                          animationIn: ["animate__animated", "animate__fadeIn"],
                          animationOut: [
                            "animate__animated",
                            "animate__fadeOut",
                          ],
                          dismiss: {
                            duration: 5000,
                            onScreen: true,
                          },
                        });
                      }
                    });
                }}
              >
                {(props) => (
                  <Form>
                    <div className="form-group">
                      <label className="form-label">Title:</label>
                      <MyTextInput
                        type="text"
                        id="title"
                        name="title"
                        placeholder="Enter title"
                        className="form-control"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Title in Spanish:</label>
                      <MyTextInput
                        type="text"
                        name="title_sp"
                        id="title_sp"
                        className="form-control"
                        placeholder="Enter title in spanish"
                      />
                    </div>
                    {getButton === true ? (
                      <Button type="submit" className="form-submit">
                        Submit
                      </Button>
                    ) : (
                      <Button type="submit" className="form-submit" disabled>
                        Please Wait!!
                      </Button>
                    )}
                  </Form>
                )}
              </Formik>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose1}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default TagManagement;
